export default __webpack_public_path__ + "static/media/img4.8e14bbc8.png";